module.exports = __webpack_public_path__ + "img/Digi_entwurf_1.d5dcd3b1.png";